<template>
  <el-image class="flex-align-justify" v-if="src" :style="style" :src="src" :fit="fit" :preview-src-list="list">
    <div slot="placeholder" class="image-slot">
      <i class="el-icon-loading is-loading"></i>
    </div>
    <div slot="error" class="image-slot">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>
<script>
import { settingApi } from '@/api';
import { getEnvGlobalConfig } from '@/utils';
export default {
  name: 'BjKeyImage',
  props: {
    url: {
      type: String,
      default: '',
    },
    fileKey: {
      type: String,
      default: '',
    },
    fit: {
      type: String,
      default: 'contain', // 确定图片如何适应容器框，同原生 object-fit	string	fill / contain / cover / none / scale-down
    },
    preview: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: 'auto',
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
  data() {
    return {
      src: null,
    };
  },
  computed: {
    list() {
      return this.src && this.preview ? [this.src] : [];
    },
    style() {
      return {
        '--height': this.height,
        '--width': this.width,
      };
    },
  },
  watch: {
    fileKey: {
      handler(v) {
        this.getUrl();
      },
      immediate: false,
    },
    url: {
      handler(v) {
        this.getUrl();
      },
      immediate: false,
    },
  },
  mounted() {
    this.getUrl();
  },
  methods: {
    getUrl() {
      if (this.fileKey) {
        settingApi
          .getFileUrlByKey({
            fileKey: this.fileKey,
            expires: 60,
          })
          .then(res => {
            if (res.failed !== true) {
              let url = res.fileTokenUrl || res.message || res;
              if (res.fileTokenUrl.indexOf('http') !== 0) {
                url = 'http://' + url;
              }
              this.src = url;
            }
          });
      }
      if (this.url) {
        if (
          this.url.indexOf('static/') == 0 ||
          this.url.indexOf('http') == 0 ||
          this.url.indexOf('blob:') == 0 ||
          this.url.indexOf('data:') == 0 ||
          this.url.indexOf('/') == 0
        ) {
          this.src = this.url;
          return;
        }
        this.$store
          .dispatch('fileUrl/getFileTokenUrl', {
            url: this.url,
            bucketName: this.bucketName || getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME'),
          })
          .then(url => {
            this.src = url;
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped vars="{ height }">
.el-image {
  background-color: inherit;
  height: var(--height);
  width: var(--width);
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
}

.is-loading {
  font-size: 20px;
  color: #409eff;
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
